import React from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import "./LoginReminderPopup.css";

const LoginReminderPopup = ({ show, onClose, onProceed, message }) => {
  const navigate = useNavigate();
  if (!show) return null;

  const popupContent = (
    <div className="popup-overlay">
      <div className="popup-box">
        <h3>{message || "Đăng nhập để nhận nhiều ưu đãi giảm giá từ JJSNAKE"}</h3>
        <div style={{ marginTop: 16, display: "flex", gap: 12, justifyContent: "center" }}>
          <button
            className="default-btn secondary"
            onClick={() => onClose && onClose()}
          >
            Bỏ qua
          </button>
          <button
            className="default-btn primary"
            onClick={() => {
              if (onProceed) {
                onProceed();
              } else {
                navigate("/login-register");
              }
              if (onClose) onClose();
            }}
          >
            Đăng nhập / Đăng ký
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(popupContent, document.body);
};

export default LoginReminderPopup;
